module.exports = __webpack_public_path__ + "media/images/icons/material/check-thin-d2f1eace34dbfbb5df99cc5ec578f7bd.svg";